import gql from 'graphql-tag';
import { UpdateBillingAccountInput } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';
import { FetchResult } from '@apollo/client';

const UPDATE_BILLING_ACCOUNT = gql`
  mutation updateBillingAccount($input: UpdateBillingAccountInput!) {
    updateBillingAccount(input: $input) {
      accountNumber
    }
  }
`;
export type UpdateBillingAccountResponse = FetchResult<{
  updateBillingAccount: {
    accountNumber: string;
  };
}>;

export default async function updateBillingAccountAsync(
  options: UpdateBillingAccountInput,
): Promise<UpdateBillingAccountResponse> {
  return client.mutate({
    mutation: UPDATE_BILLING_ACCOUNT,
    variables: {
      input: options,
    },
  });
}
